export function apiErrorHandler (
  that,
  err,
  process = () => {},
  onError = () => {}
) {
  try {
    if (err && err.errors) {
      that.$notify({
        title:
          "ネットワークの接続を確認してください。接続後はブラウザをリロードしてください。",
        message: err.errors[0].message,
        onClick: () => {
          location.reload();
        },
      });
      console.log(err.errors[0].stack);
      process();
      return;
    }
    that.$notify({ message: "エラーが発生しました" });
  } catch (err) {
    console.log("error in apiErrorHandler");
    console.log(err);
    onError(err);
  }
}
